import React from "react";
import { Field, FieldArray, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import { Form } from "@ant-design/compatible";
import { Button, Alert } from "antd";
import { GoldOutlined } from "@ant-design/icons";

import { required } from "utils/formValidations";
import { renderSelect, renderDatePicker, renderTextarea } from "components/FormItem";

import ProductFields from "./ProductFields";

const buttonsLayout = {
  wrapperCol: {
    md: { span: 15, offset: 6 },
    xs: { span: 24 },
  },
};

const tableLayout = {
  wrapperCol: {
    xs: 24,
    md: { span: 22, offset: 1 },
    lg: { span: 15, offset: 3 },
  },
};

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 10 },
    md: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    md: { span: 10 },
  },
};

const ProductionForm = ({
  handleSubmit,
  t,
  pristine,
  submitting,
  error,
  initialValues = {},
  optionsData,
  change,
}) => {
  const locationsOptions = (optionsData?.locations ?? [])
    .map((item) => ({ value: item.id, label: item.name }));

  return (
    <Form onSubmit={handleSubmit}>
      <Field
        name="datetime"
        label={t("warehouse.Productions.Form.DateAndTime.Label")}
        component={renderDatePicker}
        formItemProps={formItemLayout}
        showTime
        placeholder={t("warehouse.Productions.Form.DateAndTime.Placeholder")}
        disabled={!!initialValues.id}
        validate={required}
      />
      <Field
        name="location_id"
        label={t("warehouse.Productions.Form.Warehouse.Label")}
        component={renderSelect}
        style={{ width: 250 }}
        formItemProps={formItemLayout}
        placeholder={t("warehouse.Productions.Form.Warehouse.Placeholder")}
        options={locationsOptions}
        disabled={!!initialValues.id}
        validate={required}
      />
      <Field
        name="description"
        label={t("warehouse.Productions.Form.Description")}
        component={renderTextarea}
        formItemProps={formItemLayout}
        disabled={!!initialValues.id}
      />

      <Form.Item {...tableLayout}>
        <FieldArray
          name="production_products"
          t={t}
          component={ProductFields}
          changeField={change}
          optionsData={optionsData}
          disabled={!!initialValues.id}
        />
      </Form.Item>

      {error && (
        <Form.Item {...tableLayout}>
          <Alert message={error} type="error" />
        </Form.Item>
      )}

      <Form.Item {...buttonsLayout}>
        <Button
          type="primary"
          htmlType="submit"
          icon={<GoldOutlined />}
          disabled={!!initialValues.id || pristine || submitting}
        >
          {t("warehouse.Productions.Form.Submit")}
        </Button>
      </Form.Item>
    </Form>
  );
};

ProductionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  optionsData: PropTypes.object,
  error: PropTypes.string,
};

export default reduxForm({
  form: "productionForm",
  initialValues: {
    production_products: [],
  },
})(ProductionForm);
